(function () {
  angular.module('MktzapApp.Controllers')
    .controller('AttendanceCounterController', attendanceCounterController);

  attendanceCounterController.$inject = ['AttendanceCounterService', 'NotificationService'];

  function attendanceCounterController (AttendanceCounterService, NotificationService) {
    var vm = this;
    vm.callCommand = callCommand;

    vm.filters = {
      date: moment().format('YYYY-MM')
    };

    function callCommand () {
      AttendanceCounterService
        .callCommand(vm.filters)
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, 'Command executado');
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro na execução do command!');
        });
    }
  }
})();
